import { PublicTransmedRegistration } from "../../../../dtos/transmed/process/registration/registration";
import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "../../..";
import TransmedValidateRegistrationApi from "../../../../api/transmed/validation/registration";
import TransmedContestationApi from "../../../../api/transmed/contestation";
import {
  TransmedRegistrationContestationAnswerInput,
  TransmedRegistrationContestationAskInput,
} from "../../../../dtos/transmed/process/registration/contestation";

class TransmedRegistrationContestationServiceReader extends ServiceReader {
  public async outgoings(): Promise<PublicTransmedRegistration[]> {
    return await new TransmedValidateRegistrationApi().get();
  }
}

class TransmedRegistrationContestationServiceCreator extends ServiceCreator {
  public async contestation(question: string): Promise<void> {
    return await new TransmedContestationApi().post(
      new TransmedRegistrationContestationAskInput(question)
    );
  }
}

class TransmedRegistrationContestationServiceUpdater extends ServiceUpdater {
  public async answer(id: number, message: string): Promise<void> {
    return await new TransmedContestationApi().put(
      `${id}`,
      new TransmedRegistrationContestationAnswerInput(message)
    );
  }
}

class TransmedRegistrationContestationServiceDeleter extends ServiceDeleter {}

export default class TransmedRegistrationContestationService extends Service {
  public get read(): TransmedRegistrationContestationServiceReader {
    return new TransmedRegistrationContestationServiceReader();
  }
  public get create(): TransmedRegistrationContestationServiceCreator {
    return new TransmedRegistrationContestationServiceCreator();
  }
  public get update(): TransmedRegistrationContestationServiceUpdater {
    return new TransmedRegistrationContestationServiceUpdater();
  }
  public get delete(): TransmedRegistrationContestationServiceDeleter {
    return new TransmedRegistrationContestationServiceDeleter();
  }
}
